<template>
  <div class="flex gap-1 nested-menu-tab-button-container">
    <nested-menu-tab-button :title="$t('inbound_details')" icon="icon-list" route="callStatistics.inboundDetails"></nested-menu-tab-button>
    <nested-menu-tab-button :title="$t('outbound_details')" icon="icon-list" route="callStatistics.outboundDetails"></nested-menu-tab-button>
    <nested-menu-tab-button :title="$t('inbound_statistics')" icon="icon-bar-chart-2" route="callStatistics.inboundStatistics"></nested-menu-tab-button>
    <nested-menu-tab-button :title="$t('call_statistics')" icon="icon-bar-chart-2" route="callStatistics.callStatistics"></nested-menu-tab-button>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'

export default {
  name: 'Shared.CallStatistics.TabNav',
  components: {
    NestedMenuTabButton
  }
}
</script>

<style scoped>

</style>
